<template>
  <Layout id="Home-Page">
    <heroSection
      :header="header"
      :userStatus="isAuthenticated"
      :subHeader="subHeader"
      :subHeaderUnAuthenticated="subHeaderUnAuthenticated"
    />
    <main class="container">
      <div class="mx-auto overflow-hidden">
        <template v-for="(course,i) in courses">
          <homeCardComponent
            :key="i"
            :name="course.name"
            :image="course.image"
            :description="course.description"
            :link="course.link"
            :isAuthenticated="isAuthenticated"
          />
        </template>
        <b-modal size="lg" hide-footer v-model="modalShow" class="text-center home-modal">
          <template v-slot:modal-header="{ close }">
      <button data-event="modal" data-name="onclick" data-type="click" data-region="modal" data-section="welcome user" data-text="close" type="button" @click="close(),closeModal()" aria-label="Close" class="close">×</button>
    </template>
          <div id="welcome-window" class="text-container text-lg-center">
            <h2 class="font56 font-weight-bold m-1 mb-4">Welcome, {{first_name}}</h2>
            <p class="font18 mb-4" >Follow these three easy steps to complete your enrollment</p>
          </div>
          <div id="progress-bar" class="d-none d-lg-block">
            <div class="container-fluid">
              <ul class="list-unstyled multi-steps">
                <li>
                  <span class="map">
                    <i class="fas fa-map-marker">
                      <span class="small-text">1</span>
                    </i>
                  </span>
                  <span class="text">Choose a series</span>
                </li>
                <li>
                  <span class="map">
                    <i class="fas fa-map-marker">
                      <span class="small-text">2</span>
                    </i>
                  </span>
                  <span class="text">Select your course</span>
                </li>
                <li>
                  <span class="map">
                    <i class="fas fa-map-marker">
                      <span class="small-text">3</span>
                    </i>
                  </span>
                  <span class="text">Create a Canvas account</span>
                </li>
              </ul>
            </div>
            <div class="col-md-6 mx-auto mt-5">
              <button class="btn btn-lg btn-block btn-secondary font-weight-bold" data-event="link"
                  data-action="click"
                  data-name="onclick"
                  data-type="internal link"
                  data-region="modal"
                  data-section="welcome user"
                  data-text="lets go" @click="modalShow=false,letsGo()">Lets go</button>
            </div>
          </div>
          <div id="mobile-progress-bar" class="d-sm-block d-md-block d-lg-none">
            <div class="container-fluid">
              <ul class="list-unstyled">
                <li class="d-flex align-items-center">
                  <span class="map">
                    <i class="fas fa-map-marker">
                      <span class="small-text__mobile">1</span>
                    </i>
                  </span>
                  <span class="text font16 font-weight-bold">Choose a series</span>
                </li>
                <li class="d-flex align-items-center">
                  <span class="map">
                    <i class="fas fa-map-marker">
                      <span class="small-text__mobile">2</span>
                    </i>
                  </span>
                  <span class="text font16 font-weight-bold">Select your course</span>
                </li>
                <li class="d-flex align-items-center">
                  <span class="map">
                    <i class="fas fa-map-marker">
                      <span class="small-text__mobile">3</span>
                    </i>
                  </span>
                  <span class="text font16 font-weight-bold">Create a Canvas account</span>
                </li>
              </ul>
            </div>
            <div class="col-md-6 mx-auto mt-3">
              <button class="btn btn-lg btn-block btn-secondary font-weight-bold" data-event="link"
                  data-action="click"
                  data-name="onclick"
                  data-type="internal link"
                  data-region="modal"
                  data-section="welcome user"
                  data-text="lets go" @click="modalShow=false,letsGo()">Lets go</button>
            </div>
          </div>
        </b-modal>
      </div>
    </main>
  </Layout>
</template>

<script>
import Layout from "../layouts/main";
import heroSection from "../components/heroSectionHome";
import homeCardComponent from "../components/homeCard";
import { REDIRECTED_USER, LOGIN_USER_CANVAS,EMAIL_VALIDATION ,CHECK_AUTH } from "../store/actions.type";
import { mapGetters } from "vuex";
import Vue from "vue";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

export default {
  name: "Home-Component",
  components: { Layout, heroSection, homeCardComponent },

  async beforeMount() {
    let rfi_id = this.$route.query.rfi_id;
    let code = this.$route.query.code;
    let state = this.$route.query.state;
    if (code) {
      let data = await this.$store.dispatch(LOGIN_USER_CANVAS, {
        data: { code: code }
      }).then(this.$router.replace({ code }));
      
    }
    if (rfi_id) {
      let data = await this.$store.dispatch(REDIRECTED_USER, rfi_id);
      if (data.user.status === "lead") {
        this.first_name = data.user.first_name;
        this.modalShow = true;
        this.$store.state.currentPage = "home";
        let existingCanvasUser = await this.$store.dispatch(EMAIL_VALIDATION, data.email_address)

      }else{
        this.$store.dispatch(CHECK_AUTH,"router");
      }
    }
    this.$store.state.currentPage = "home";
  },
  computed: {
    ...mapGetters(["currentUser", "isAuthenticated"])
  },
  methods:{
    closeModal(){
    utag.link({
            event: 'modal',
            action: 'close',
            name: 'onclick',
            type: 'click',
            region: 'modal',
            section: 'welcome user',
            text: 'close',
            tealium_event: 'close_modal'
        })
    },
    letsGo(){
      utag.link({
        event: 'link',
        action: 'click',
        name: 'onclick',
        type: 'internal link',
        region: 'modal',
        section: 'welcome user',
        text: 'lets go',
        tealium_event: 'lets_go_button_click_event'
    })
    }
  },
  mounted(){
    if(this.isAuthenticated){
if(this.currentUser.user.status === 'ineligible'){
      Vue.swal({
        showConfirmButton: false,
              type: "error",
              title: "Whoops!!!",
              html: "It doesn't look like you're an Uber partner or family member<br> Think we made a mistake? <button class='btn btn-secondary'>Contact support</button>"
            });
    }
    }
  },
  data() {
    return {
      modalShow: false,
      header: "Course Enrollment Portal",
      first_name: "",
      subHeader: "Choose a series of courses you are interested in below",
      subHeaderUnAuthenticated:
        "Log in to your Canvas account to browse courses, read descriptions and enroll.",
      courses: [
        {
          name: "Entrepreneurship",
          link: "Entrepreneurship",
          image: "ENT_Catalog_Tile_Image.png",
          description:
            "Learn how to start, build and run a successful business with five courses in entrepreneurship from Arizona State University."
        },
        {
          name: "English Language Learning",
          link: "English",
          image: "ESL_Catalogue_Tile_Image.png",
          description:
            "Improve your reading, writing, grammar, listening and speaking skills, with eight courses in ELL from Arizona State University."
        }
      ]
    };
  }
};
</script>
